/**
 * Investor List Page
 * ==================
 * Main page for viewing and managing investors
 */

import React from 'react';
import { Card, CardHeader, CardBody, Button } from '../../components/ui';
import { DashboardLayout } from '../../components/layout';

const InvestorListPage = () => {
  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h1 className="text-[28px] font-sans font-bold text-gray-900 dark:text-white mb-2">
              Investors
            </h1>
            <p className="text-gray-500 dark:text-gray-400">
              Manage investor relationships, distribution, and market readiness
            </p>
          </div>
        </div>

        {/* Coming Soon Card */}
        <Card>
          <CardHeader>
            <h2 className="text-2xl font-sans font-semibold text-gray-900 dark:text-white">
              Module Under Development
            </h2>
          </CardHeader>
          <CardBody>
            <div className="text-center py-12">
              <div className="w-24 h-24 mx-auto mb-6 bg-gradient-primary rounded-full flex items-center justify-center">
                <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              
              <h3 className="text-xl font-sans font-semibold text-gray-900 dark:text-white mb-3">
                Coming Soon
              </h3>
              
              <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                The Investors module is currently under development. This module will include:
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto mb-8">
                <div className="bg-gray-50 rounded-lg p-4 text-left">
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-accent mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <div>
                      <h4 className="font-medium text-gray-900 mb-1">Investor Database</h4>
                      <p className="text-sm text-gray-600">Manage investor profiles and preferences</p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 text-left">
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-accent mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <div>
                      <h4 className="font-medium text-gray-900 mb-1">Distribution Intelligence</h4>
                      <p className="text-sm text-gray-600">Market readiness and investor targeting</p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 text-left">
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-accent mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <div>
                      <h4 className="font-medium text-gray-900 mb-1">KYC/AML Management</h4>
                      <p className="text-sm text-gray-600">Investor verification and compliance</p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 text-left">
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-accent mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <div>
                      <h4 className="font-medium text-gray-900 mb-1">Distribution Coordination</h4>
                      <p className="text-sm text-gray-600">Partner and channel management</p>
                    </div>
                  </div>
                </div>
              </div>

              <Button variant="primary" disabled>
                Module Coming Soon
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default InvestorListPage;

